// Fish Audio Semantic V2 class recipes shared by the UI primitives.
export type Variant = "primary" | "secondary" | "tertiary" | "danger";
export type Size = "md" | "lg" | "sm";

const VARIANT: Record<Variant, string> = {
  primary: "bg-primary text-on-primary hover:bg-primary-hover",
  secondary: "bg-secondary text-title hover:bg-secondary-hover",
  tertiary: "text-title hover:bg-fill",
  danger: "bg-danger text-white hover:opacity-90",
};
const SIZE: Record<Size, string> = { sm: "h-8 px-3 text-xs", md: "h-10 px-4 text-sm", lg: "h-12 px-[22px] text-base" };

export function buttonClass(variant: Variant = "primary", size: Size = "md", extra = "") {
  return `inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--fish-v2-border-input-focus)] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-40 ${VARIANT[variant]} ${SIZE[size]} ${extra}`;
}

export const inputClass =
  "h-10 rounded-xl border border-[var(--fish-v2-border-input)] bg-elevated px-3 text-sm text-title placeholder:text-disabled hover:border-[var(--fish-v2-border-input-hover)] focus:border-[var(--fish-v2-border-input-focus)] focus:outline-none";

/** Page frame shared by the header, main and footer: up to 1600 px wide, so wide screens are used (long copy keeps its own max-w-prose). */
export const shellClass = "mx-auto w-full max-w-[100rem] px-3 sm:px-6 lg:px-8";

/** A comfortable centred column for forms (onboarding steps, sign-in). */
export const narrowClass = "mx-auto w-full max-w-2xl";
